'use strict';

module.exports = {
  loginPage: {
    login: function(ga) {
      ga.event('ログインページ', 'ログイン', '', 1);
    },
    terms: function(ga) {
      ga.event('ログインページ', '利用規約', '', 1);
    },
    privacy: function(ga) {
      ga.event('ログインページ', 'プライバシーポリシー', '', 1);
    },
  },
  landingPage: {
    login: function(ga) {
      ga.event('LP', 'ログイン', '', 1);
    },
    terms: function(ga) {
      ga.event('LP', '利用規約', '', 1);
    },
    privacy: function(ga) {
      ga.event('LP', 'プライバシーポリシー', '', 1);
    },
  },
  partnerPage: {
    link: function(ga) {
      ga.event('パートナー連携画面', '連携', '', 1);
    },
    home: function(ga) {
      ga.event('パートナー連携画面', 'ホームへ遷移', '', 1);
    },
    login: function(ga) {
      ga.event('パートナー連携画面', 'ログイン', '', 1);
    },
  },
  tripPage: {
    /**
     * @param {Object} ga GAに送るためのクライアント
     * @param {String} prefecture 都道府県
     */
    move: function(ga, prefecture) {
      ga.event('Tripページ', '遷移', prefecture, 1);
    },
  },
  memory: {
    moveMemories: function(ga) {
      ga.event('思い出', '詳細ページ遷移', 'Memoriesページ', 1);
    },
    moveHistory: function(ga) {
      ga.event('思い出', '詳細ページ遷移', 'Historyページ', 1);
    },
    sortMemories: function(ga) {
      ga.event('思い出', '並び替え', 'Memoriesページ', 1);
    },
    sortHistory: function(ga) {
      ga.event('思い出', '並び替え', 'Historyページ', 1);
    },
    delete: function(ga) {
      ga.event('思い出', '削除', '', 1);
    },
  },
  settings: {
    unlinkPartner: function(ga) {
      ga.event('設定モーダル', 'パートナー連携解除', '', 1);
    },
    userDelete: function(ga) {
      ga.event('設定モーダル', 'ユーザ削除', '', 1);
    },
  },
  fab: {
    openCreate: function(ga) {
      ga.event('FAB', '登録モーダル表示', '', 1);
    },
    openEdit: function(ga) {
      ga.event('FAB', '編集モーダル表示', '', 1);
    },
    create: function(ga) {
      ga.event('FAB', '思い出登録', '', 1);
    },
    edit: function(ga) {
      ga.event('FAB', '思い出編集', '', 1);
    },
    helpCreate: function(ga) {
      ga.event('FAB', '公開/非公開について', '登録モーダル', 1);
    },
    helpEdit: function(ga) {
      ga.event('FAB', '公開/非公開について', '編集モーダル', 1);
    },
  },
  bottomMenu: {
    /**
     * @param {Object} ga GAに送るためのクライアント
     * @param {String} path 遷移するページのパス
     *
     * path: trip, history, gallery
     */
    move: function(ga, path) {
      ga.event('ボトムメニュー', `${path}ページ遷移`, '', 1);
    },
  },
  sideMenu: {
    partnerChange: function(ga) {
      ga.event('サイドメニュー', 'パートナー切り替え', '', 1);
    },
    partnerLink: function(ga) {
      ga.event('サイドメニュー', 'パートナー連携', '', 1);
    },
    terms: function(ga) {
      ga.event('サイドメニュー', '利用規約', '', 1);
    },
    privacy: function(ga) {
      ga.event('サイドメニュー', 'プライバシーポリシー', '', 1);
    },
    inquiry: function(ga) {
      ga.event('サイドメニュー', 'お問い合わせ', '', 1);
    },
    settings: function(ga) {
      ga.event('サイドメニュー', '設定', '', 1);
    },
    logout: function(ga) {
      ga.event('サイドメニュー', 'ログアウト', '', 1);
    },
  },
  snackbar: {
    /**
     * @param {Object} ga GAに送るためのクライアント
     * @param {Object} val スナックバーに表示する項目
     *
     * val.color: success, info, warning, error
     */
    alert: function(ga, val) {
      ga.event('アラート', val.color, val.text, 1);
    },
  },
};
